import DefaultProfile from "@/assets/graphics/default-profile.svg";
import { UserRoles } from "@/api/users/types";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { Profile } from "../types";
import { twMerge } from "tailwind-merge";
import ThemedImage from "@/app/(components)/Basic/Image/ThemedImage";

export interface Props {
  profile: Profile;
  className?: string;
}

const ProfileImage = ({ profile, className }: Props) => {
  return (
    <div className={twMerge(className, "relative flex lg:ml-14 w-40 h-40")}>
      {profile.imageUrl ? (
        <ImageTypeHandler
          src={profile.imageUrl}
          placeholder={profile.imagePlaceholder}
          alt={profile?.displayName || "unnamed"}
          width={160}
          height={160}
          className="rounded-full object-cover min-w-[160px] min-h-[160px]"
        />
      ) : (
        <DefaultProfile />
      )}
      {profile.role == UserRoles.ARTIST && (
        <>
          {" "}
          {profile.openToWork && (
            <ThemedImage
              imageName="open-to-work"
              alt={`${profile.displayName} profile image`}
              width={161}
              height={161}
              className="absolute top-0 left-0 right-0 bottom-0"
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProfileImage;
